// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Introduce_style_wrap__3XBWz","btnBox":"Introduce_style_btnBox__1CsDr"};